import React from "react";

export default function CelebrationWhy() {
  return (
    <section className="w-full bg-[var(--celebration-yellow)] py-16 md:py-24">
      <div className="mx-auto theme-container text-center">
        <span
          className="mb-6 inline-block rounded-full border border-black/10 bg-white/40 px-5 py-3 font-medium leading-none text-main-black"
          data-aos="fade-up"
        >
          20 Years of Asking Why
        </span>
        <h2
          className="mx-auto mt-6 max-w-3xl text-34 font-semibold text-main-black md:text-48"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Big Impact starts with Big Questions
        </h2>
        <p
          className="mx-auto mt-6 max-w-3xl leading-relaxed text-main-black/80"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          The technology we use changes every day. Our commitment to excellence does not. That's why we believe that technology exists to <strong>solve human problems</strong>. That's why we ask questions that other agencies don't think to. That’s why, after all these years, we’re still - <strong className="celebration-agency-underline">The Agency of Why</strong>. And we're grateful to those intrepid clients who lean in to their Why.
        </p>
      </div>
    </section>
  );
}
